import { useState } from "react";
import { UsersListLoading } from "../../Reviews/Review/users-list/components/loading/UsersListLoading";
import { KTCardBody } from "../../../../_metronic/helpers";
import { Pagination } from "../../../../components/Pagination";
import clsx from "clsx";
import { ConfirmOrgModal } from "../ConfirmOrgModal/ConfirmOrgModal";
import { MembersModal } from "../membersModal/MembersModal";
import { toast } from "react-toastify";
import axios from "axios";
import moment from "moment";

const headers = [
  { title: 'Organization Name', width: '300px', sort_key: 'org_name' },
  { title: 'Owner Name', width: '180px' },
  { title: 'Dot Number', width: '180px' },
  { title: 'Members', width: '180px', sort_key: 'members' },
  { title: 'Active Listings', width: '180px', sort_key: 'listings_owned' },
  { title: 'Status', width: '100px', sort_key: 'status' },
  { title: 'Description', width: '200px', className: 'text-center' },
  { title: 'Created At', width: '180px', sort_key: 'org_creation' },
  { title: 'Action', width: '120px', className: 'text-center' },
]

const sortMap = [
  {
    id: 1,
    key: 'org_name',
    order: 'asc'
  },
  {
    id: 2,
    key: 'org_name',
    order: 'desc'
  },
  {
    id: 3,
    key: 'org_creation',
    order: 'asc'
  },
  {
    id: 4,
    key: 'org_creation',
    order: 'desc'
  },
  {
    id: 5,
    key: 'members',
    order: 'asc'
  },
  {
    id: 6,
    key: 'members',
    order: 'desc'
  },
  {
    id: 7,
    key: 'listings_owned',
    order: 'asc'
  },
  {
    id: 8,
    key: 'listings_owned',
    order: 'desc'
  }
]


const orgStatus = (status) => {
  switch (status) {
    case 'deleted':
      return {
        text: 'Deleted',
        class: 'bg-danger text-white'
      }
    case 'created':
      return {
        text: 'Created',
        class: 'bg-succes text-white'
      }
    case 'active':
      return {
        text: 'Active',
        class: 'bg-success text-white'
      }
    case 'pending':
      return {
        text: 'Pending',
        class: 'bg-main text-white'
      }
    default:
      return {
        text: 'Active',
        class: 'bg-success text-white'
      }
  }
}

export const OrgTable = ({ organizations, isLoading, setLoading, haveAccess, currentUser, fetchOrganizations, page, setPage, pageSize, setPageSize, total, setSort, sort }) => {
  const [openConfirmOrgModal, setOpenConfirmOrgModal] = useState({
    isOpen: false,
    type: null
  });
  const [orgId, setOrgId] = useState(null);
  const [openMembersModal, setOpenMembersModal] = useState(false);
  const [orgDetails, setOrgDetails] = useState(null);


  const getOrgDetails = (id) => {
    setLoading(true)
    axios.get(`${process.env.REACT_APP_API_V3_URL}/org/${id}`)
        .then((res) => {
          setOrgDetails(res.data);
          setOpenMembersModal(true);
          setLoading(false)
        }).catch((err) => {
      setLoading(false)
      toast.error(err.response.data.message || 'Something went wrong');
    })
  }

  const sortColumn = (key) => {
    const nextOrder = sort.order === 'desc' && sort.key === key ? 'asc' : 'desc';
    const nextSort = sortMap.find(s => s.key === key && s.order === nextOrder);

    if (nextSort) {
      setSort(nextSort);
    }
  };


  return (
      <KTCardBody className='py-4'>
        <div className='table-responsive'>
          <table
              id='kt_table_users'
              className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
          >
            <thead>
            <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
              {headers.map(column => {
                const isSorted = column.sort_key === sort.key;
                const orderClass = isSorted ? `table-sort-${sort.order}` : 'table-sort';
                return (
                    <th
                        key={column.title}
                        className={`${orderClass} ${column.className} ${column.sort_key ? 'pointer' : ''}`}
                        style={{ minWidth: column.width }}
                        onClick={() => column.sort_key && sortColumn(column.sort_key)}
                    >
                      {column.title}
                    </th>
                );
              })}
            </tr>
            </thead>
            <tbody className='text-gray-600 fw-bold'>
            {organizations && organizations.length > 0 && (
                organizations.map(row => (
                    <tr key={row.role_id}>
                      <td style={{ minWidth: headers[1].width }}>
                        <div className="d-flex align-items-center">
                          <div className="symbol symbol-circle symbol-50px overflow-hidden me-3" style={{ width: '50px', height: '50px' }}>
                            {row.org_logo && row.org_logo !== null ? (
                                    <div className='w-100 h-100'>
                                      <img src={process.env.REACT_APP_IMAGE_URL + '200:200:' + row?.org_logo.slice(1)} alt={row.org_name} className='w-100 h-100' />
                                    </div>
                                ) :
                                <div
                                    className={clsx(
                                        "symbol-label fs-3",
                                        `bg-light-primary`,
                                        `text-primary`
                                    )}
                                >
                                  {row?.org_name?.slice(0, 1)}
                                </div>
                            }
                          </div>
                          <div className="d-flex flex-column mx-2">
                        <span className="text-gray-800 mb-1">
                          {row.org_name}
                        </span>
                          </div>
                        </div>
                      </td>
                      <td style={{ minWidth: headers[1].width }}>{row.owner_name}</td>
                      <td style={{ minWidth: headers[2].width }}>{row.dot_number || '-'}</td>
                      <td style={{ minWidth: headers[3].width }}
                          className="pointer"
                          onClick={() => getOrgDetails(row.org_id)}
                      >
                        <div className="d-flex flex-column gap-1 text-center" style={{ width: 'max-content' }}>
                          <span className="badge badge-light-primary fw-bolder fs-5" style={{ width: 'max-content' }}>{row.members} Members</span>
                          <span>[View All]</span>
                        </div>
                      </td>
                      <td style={{ minWidth: headers[4].width }}>{row.listings_owned}</td>
                      <td style={{ minWidth: headers[5].width }}>
                    <span className={`badge fw-bolder fs-5 ${orgStatus(row.status).class}`}>
                      {orgStatus(row.status).text}
                      </span>
                      </td>
                      <td style={{ minWidth: headers[5].width, textAlign: 'center' }}>
                        {row.description || '-'}
                      </td>
                      <td style={{ minWidth: headers[6].width }}>{moment(row.org_creation).format('YYYY-MM-DD')}</td>
                      <td style={{ minWidth: headers[7].width, textAlign: 'center' }}>
                        {row.status === 'pending' &&
                            <button
                                className="btn btn-sm btn-success w-100"
                                disabled={(haveAccess(currentUser, 'org_delete') ? false : true) || isLoading}
                                onClick={() => {
                                  setOpenConfirmOrgModal({
                                    isOpen: true,
                                    type: 'Approve',
                                  });
                                  setOrgId(row.org_id);
                                }}
                            >
                              Approve
                            </button>
                        }
                        {row.status !== 'deleted' ? <button
                                className="btn btn-danger btn-sm w-100"
                                disabled={(haveAccess(currentUser, 'org_delete') ? false : true) || isLoading || row.status === 'active'}
                                onClick={() => {
                                  setOpenConfirmOrgModal({
                                    isOpen: true,
                                    type: 'Delete',
                                  })
                                  setOrgId(row.org_id);
                                }}
                            >
                              Delete
                            </button>
                            : '-'
                        }
                      </td>
                    </tr>
                ))
            )}
            </tbody>
          </table>
          {organizations && !organizations?.length &&
              <div className='d-flex text-center text-gray-600 fw-bolder fs-6 w-100 align-content-center justify-content-center mt-10'>
                No matching records found
              </div>
          }
        </div>
        <Pagination
            page={page}
            setPage={setPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            total={total}
        />
        {isLoading && <UsersListLoading />}
        {openConfirmOrgModal && openConfirmOrgModal?.isOpen && orgId && (
            <ConfirmOrgModal openConfirmOrgModal={openConfirmOrgModal} setOpenConfirmOrgModal={setOpenConfirmOrgModal} orgId={orgId} setOrgId={setOrgId} fetchOrganizations={fetchOrganizations} />
        )}
        {
            openMembersModal && orgDetails &&
            <MembersModal orgName={orgDetails?.org_name} members={orgDetails?.members} onClose={() => {
              setOpenMembersModal(false);
              setOrgDetails(null);
            }} />
        }
      </KTCardBody>
  );
};
